import { Routes } from '@angular/router';
import { AuthGuardService } from './core/guard/auth-guard.service';
import { ModuloAcessoGuardService } from './core/guard/modulo-acesso-guard.service';
import { PainelEmbutidoGuardService } from './core/guard/painel-embutido-guard.service';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' }, // <- Adicionando '/' antes do login
    {
      path: 'login',
      loadComponent: () => import('./features/login-portal/login-portal.component').then(m => m.LoginPortalComponent)
    },
    {
      path: 'home',
      loadComponent: () => import('./features/home-menu/home-menu.component').then(m => m.HomeMenuComponent),
      canActivate :[AuthGuardService]
    },
    { path: 'modulos', redirectTo: 'home', pathMatch: 'full' },
    {
      path: 'modulos/:modulo',
      loadComponent: () => import('./features/funcionalidades/funcionalidades.component').then(m => m.FuncionalidadesComponent),
      canActivate: [AuthGuardService, ModuloAcessoGuardService]
    },
    {
      path: 'menus',
      loadComponent: () => import('./features/cadastro-menus/cadastro-menus.component').then(m => m.CadastroMenusComponent),
      canActivate: [AuthGuardService, PainelEmbutidoGuardService]
    },
    {
      path: 'configurar-menu',
      loadComponent: () => import('./features/cadastro-menus/configurar-menu/configurar-menu.component').then(m => m.ConfigurarMenuComponent),
      canActivate: [AuthGuardService, PainelEmbutidoGuardService]
    },
    {
      path: 'usuarios',
      loadComponent: () => import('./features/manutencao-usuarios/manutencao-usuarios.component').then(m => m.ManutencaoUsuariosComponent),
      canActivate: [ AuthGuardService, PainelEmbutidoGuardService ]
    },
    {
      path: 'cadastro-usuario',
      loadComponent: () => import('./features/manutencao-usuarios/cadastro-usuario/cadastro-usuario.component').then(m => m.CadastroUsuarioComponent),
      canActivate: [ AuthGuardService, PainelEmbutidoGuardService ]
    },
    {
      path: 'detalhe-usuario',
      loadComponent: () => import('./features/manutencao-usuarios/detalhe-usuario/detalhe-usuario.component').then(m => m.DetalheUsuarioComponent),
      canActivate: [ AuthGuardService, PainelEmbutidoGuardService ]
    },
    {
      path: 'admin/sessoes',
      loadComponent: () => import('./features/admin-sessoes/admin-sessoes.component').then(m => m.AdminSessoesComponent),
      canActivate: [ AuthGuardService, PainelEmbutidoGuardService ]
    },
    {
      path: 'microfrontend/:slug',
      loadComponent: () => import('./features/microfrontend-host/microfrontend-host.component').then(m => m.MicrofrontendHostComponent),
      canActivate: [ AuthGuardService  ]
    },
    { path: '**', redirectTo: 'login' } // <- Adicionando '/' para garantir que a URL seja resolvida corretamente
  ];
